if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();
      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.cardButtons = this.querySelector('.card__buttons');
      this.currentVariantId = null;
      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }
    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }
    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });
      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);
      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      // Listen for variant changes on the product section
      this.productSection.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      // Also listen on document for broader compatibility
      document.addEventListener('on:variant:change', (e) => {
        if (this.productSection.contains(e.target)) {
          this.handleVariantChange(e);
        }
      });
    }

    handleVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (variant && variant.id && variant.available) {
        // Variant selected and available - show ATC button
        this.currentVariantId = variant.id;
        this.showAtcButton(variant.id);
      } else if (variant && variant.id && !variant.available) {
        // Variant selected but unavailable
        this.currentVariantId = variant.id;
        this.showUnavailableButton();
      } else {
        // No variant selected - show choose options
        this.currentVariantId = null;
        this.showChooseOptionsButton();
      }
    }

    showAtcButton(variantId) {
      if (!this.cardButtons) return;
      this.cardButtons.innerHTML = `
        <button
          type="button"
          class="btn btn--primary btn--sm ea-sticky-atc-btn"
          data-variant-id="${variantId}"
          style="background-color: rgb(234,88,12); border-color: rgb(234,88,12); color: #fff;"
        >
          Tilføj til kurv
        </button>
      `;
      const btn = this.cardButtons.querySelector('.ea-sticky-atc-btn');
      if (btn) {
        btn.addEventListener('click', () => this.addToCart(variantId));
      }
    }

    showUnavailableButton() {
      if (!this.cardButtons) return;
      this.cardButtons.innerHTML = `
        <button type="button" class="btn btn--secondary btn--sm" disabled>
          Ikke på lager
        </button>
      `;
    }

    showChooseOptionsButton() {
      if (!this.cardButtons) return;
      // Restore original choose options link
      const anchor = this.productSection.querySelector('[data-variant-picker]') ? 'variants' : 'product-info';
      this.cardButtons.innerHTML = `
        <a class="btn btn--secondary btn--sm" href="#${anchor}" rel="nofollow">
          Vælg mulighed
        </a>
      `;
    }

    addToCart(variantId) {
      const btn = this.cardButtons.querySelector('.ea-sticky-atc-btn');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Tilføjer...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(r => r.json())
      .then(() => {
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true }));
        // Open cart drawer if available
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        if (btn) {
          btn.textContent = 'Tilføjet ✓';
          btn.style.backgroundColor = '#16a34a';
          btn.style.borderColor = '#16a34a';
          setTimeout(() => {
            if (btn) {
              btn.textContent = 'Tilføj til kurv';
              btn.style.backgroundColor = 'rgb(234,88,12)';
              btn.style.borderColor = 'rgb(234,88,12)';
              btn.disabled = false;
            }
          }, 2000);
        }
      })
      .catch(() => {
        if (btn) {
          btn.textContent = 'Tilføj til kurv';
          btn.disabled = false;
        }
      });
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }
  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
